import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { IconSearch } from '../../../common/icons/cdl/Search';
import { Box } from '../../../common/ui/Box';

export const ContractsNoResultsState = () => {
    return (
        <Box marginTop="124px" display="flex" justifyContent="center">
            <StatePlaceholder
                Icon={IconSearch}
                title={translate('contracts.noResults.title')}
                description={translate('contracts.noResults.description')}
            />
        </Box>
    );
};
